// extracted by mini-css-extract-plugin
var _1 = "dCjHRarpkIOuH25VGvtW";
var _2 = "u4lAGcu1lXPRjk9zbqjq";
var _3 = "E1yzv7sMnOaAe2MszcH3";
var _4 = "LCZkNqffwDjpYqlAUgBp";
var _5 = "GVcB8l9FLXcHQ4e5KGS_";
var _6 = "KcAyWbqltb63flaJ9p5w";
var _7 = "hRYIr_ngBy3PYL706w_6";
var _8 = "zEEpnhJDtp7RLm9gjYFM";
export { _1 as "colAction", _2 as "colComponentId", _3 as "colGroup", _4 as "colLocations", _5 as "colName", _6 as "colQuantity", _7 as "highlight", _8 as "modelComponentsTable" }
